import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_VDAY_70: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_VDAY_70,
  },
  {
    pageId: PageId.CHAT_UPSELL_VDAY_70,
  },
  {
    pageId: PageId.UPSELL_VDAY_70,
  },
  {
    pageId: PageId.DOWNLOAD_VDAY_70,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
